<template>
    <div class="publictemplate">
        <v-app
            style="background: #EEEEEE;"
        >
        <Publicheader></Publicheader>
        <v-main>
          <!-- <v-container> -->
            <router-view></router-view>
          <!-- </v-container> -->
        </v-main>
        </v-app>
    </div>
</template>
<script>
import Publicheader from '@/components/Publicheader/publicheader'
export default {
    name: 'publictemplate',
    components: { 
        Publicheader
    },
    setup() {
        
    },
}
</script>